import { classNames } from '@movingimage-evp/mi-ui-component-library';
import { useLocation } from 'react-router';

import { ChatType } from '../../generated/graphql-viewer';
import { useAbsoluteRoutes } from '../../routes';

import styles from '../dev-tools.module.css';

type Props = {
  chatType?: ChatType;
  namesVisible?: boolean;
  onTypeChange: (value?: ChatType) => void;
  onNameVisibilityChange: (value: boolean) => void;
};

export function MockedViewerChat({ chatType, namesVisible, onTypeChange, onNameVisibilityChange }: Props) {
  const { pathname } = useLocation();
  const { viewer } = useAbsoluteRoutes();

  if (!pathname.startsWith(viewer)) return null;

  return (
    <div className={styles.moduleWrapper}>
      <span>Viewer chat</span>

      {Object.values(ChatType).map((chat) => (
        <button
          key={chat}
          className={classNames(chatType === chat && styles.active)}
          onClick={() => onTypeChange(chatType === chat ? undefined : chat)}
        >
          {chat}
        </button>
      ))}

      <button
        className={classNames(namesVisible === true && styles.active)}
        onClick={() => onNameVisibilityChange(!namesVisible)}
      >
        Names visible
      </button>
    </div>
  );
}
